import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "mainForm",
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: _vm.formIsValid,
      callback: function ($$v) {
        _vm.formIsValid = $$v;
      },
      expression: "formIsValid"
    }
  }, [_c('core-header', {
    attrs: {
      "headline": 'DRAWER LINKS',
      "subtitle": 'DEFINE A CUSTOM NAVIGATION DRAWER LINK CONFIG',
      "isSaving": _vm.isSaving,
      "formIsValid": _vm.formIsValid,
      "saveButton": ""
    },
    on: {
      "saveData": _vm.saveDrawerLinks
    }
  }), _vm.hasLoadedTenants ? _c('div', {
    key: `tenant-${_vm.selectedTenantId}`,
    staticClass: "n20-mainrow pt-4"
  }, [_vm.tenants.length > 1 ? _c('core-n20Card', [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VAutocomplete, {
    staticClass: "px-2",
    attrs: {
      "label": _vm.$i18n_t('accMgmt.system.tenantSelector'),
      "items": _vm.tenants,
      "color": _vm.color,
      "value": _vm.selectedTenantId,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "hide-details": ""
    },
    on: {
      "input": _vm.selectTenant
    }
  })], 1)], 1) : _vm._e(), _vm.selectedTenantId ? _c('core-n20Card', {
    attrs: {
      "title": 'DRAWER LINKS'
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "color": _vm.color,
            "rounded": "",
            "text": ""
          },
          on: {
            "click": _vm.resetDrawerLinks
          }
        }, [_c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("fal fa-redo")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.reset')) + "\n          ")], 1)];
      },
      proxy: true
    }], null, false, 1920276750)
  }, [_c('p', {
    staticClass: "px-4 mt-4"
  }, [_vm._v("\n          EDIT THE DRAWER LINKS FOR THIS ACCOUNT/DOMAIN AND THEIR PERMISSIONS.\n          "), _c('strong', [_vm._v("NOTE:")]), _vm._v("\n          THIS WILL BE PUSHED OUT TO ALL SUBACCOUNTS AS WELL, UNLESS THEY HAVE A CONFIGURED DOMAIN WITH AN OWN DRAWER\n          LINK CONFIG!\n        ")]), _vm.tenantTheme && _vm.tenantTheme.drawerLinks !== null && _vm.tenantTheme.drawerLinks !== undefined ? _c(VCard, {
    staticClass: "pa-4"
  }, [_c(VExpansionPanels, {
    staticClass: "my-4",
    attrs: {
      "value": null,
      "flat": ""
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("AVAILABLE PERMISSIONS")])]), _c(VExpansionPanelContent, [_vm._v("\n                THESE ARE ALL PERMISSIONS THAT CAN BE CHECKED.\n                "), _c('ul', _vm._l(Object.keys(_vm.permissions).filter(p => /\.tenantIds$/gi.exec(p) === null), function (permission, j) {
    return _c('li', {
      key: `permission_${j}`
    }, [_vm._v("\n                    " + _vm._s(permission) + "\n                  ")]);
  }), 0)])], 1)], 1), _c('core-tenant-drawer-links-edit', {
    attrs: {
      "tenantTheme": _vm.tenantTheme,
      "disabled": false,
      "hierarchyIndices": []
    },
    on: {
      "remove": function ($event) {
        _vm.tenantTheme.drawerLinks = [];
      },
      "drawerlinks-changed": function ($event) {
        return _vm.refreshDrawerLinks();
      }
    }
  })], 1) : _c(VCard, [_vm._v("\n          NO DRAWER LINKS CONFIG CREATED FOR THIS ACCOUNT. WANT TO CREATE ONE?\n          "), _c('p'), _c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": _vm.createDrawerLinksConfig
    }
  }, [_c(VIcon, {
    staticClass: "mr-2",
    attrs: {
      "dark": "",
      "small": ""
    }
  }, [_vm._v("fal fa-rocket-launch")]), _vm._v("\n            EMPTY CONFIG\n          ")], 1), _c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.defaultDrawerLinksConfig();
      }
    }
  }, [_c(VIcon, {
    staticClass: "mr-2",
    attrs: {
      "dark": "",
      "small": ""
    }
  }, [_vm._v("fal fa-stream")]), _vm._v("\n            DEFAULT CONFIG\n          ")], 1)], 1)], 1) : _vm._e(), _c('br'), _c('br')], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };